import ReactMarkdown, { type Components } from "react-markdown";
import remarkGfm from "remark-gfm";

/**
 * Mapped by hand, because `@tailwindcss/typography`'s defaults would fight the JBNL tokens rather
 * than use them. A small set: the handleiding is task prose, not the whole Markdown surface (#102).
 */
const components: Components = {
  h1: ({ children }) => <h1 className="mb-3 text-xl">{children}</h1>,
  h2: ({ children }) => <h2 className="mt-6 mb-2 text-lg">{children}</h2>,
  h3: ({ children }) => <h3 className="mt-4 mb-2 text-base">{children}</h3>,
  p: ({ children }) => <p className="mb-4 leading-relaxed">{children}</p>,
  ul: ({ children }) => <ul className="mb-4 list-disc space-y-1 pl-6">{children}</ul>,
  ol: ({ children }) => <ol className="mb-4 list-decimal space-y-1 pl-6">{children}</ol>,
  a: ({ children, href }) => (
    <a className="jb-link" href={href}>
      {children}
    </a>
  ),
  img: ({ src, alt }) => (
    <img src={src} alt={alt} className="my-4 rounded-lg border border-border" />
  ),
  blockquote: ({ children }) => (
    <blockquote className="my-4 border-l-4 border-border pl-4 text-muted-foreground italic">
      {children}
    </blockquote>
  ),
  code: ({ children }) => (
    <code className="rounded bg-muted px-1 py-0.5 font-mono text-sm">{children}</code>
  ),
  hr: () => <hr className="my-6 border-border" />,
  table: ({ children }) => (
    <table className="mb-4 w-full border-collapse text-sm">{children}</table>
  ),
  th: ({ children }) => (
    <th className="border border-border bg-muted px-2 py-1 text-left">{children}</th>
  ),
  td: ({ children }) => <td className="border border-border px-2 py-1">{children}</td>,
};

export function MarkdownContent({ markdown }: { markdown: string }) {
  return (
    <ReactMarkdown remarkPlugins={[remarkGfm]} components={components}>
      {markdown}
    </ReactMarkdown>
  );
}
